import { GeneralMuiModal } from '@components/shared/general-mui-modal';
import { useModalDimensions } from '@hooks/useModalDimensions';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

type SelectingSpecialistModalProps = {
	specialist: any;
	open: boolean;
	loading: boolean;
	onClose: () => void;
	onSuccess: () => void;
};

export function SelectingSpecialistModal({
	specialist,
	open,
	loading,
	onSuccess,
	onClose,
}: SelectingSpecialistModalProps) {
	const modalDimensions = useModalDimensions();
	const { t } = useTranslation();

	return (
		<GeneralMuiModal
			maxWidth="sm"
			title={t('requestsAndOffers.selectingTheSpecialist')}
			styles={{
				paperStyle: { width: modalDimensions, height: 'auto', padding: 0 },
				contentStyle: { padding: 0 },
			}}
			open={open}
			onClose={onClose}
			content={
				<div className="flex flex-col gap-4">
					<div className="py-5 flex justify-center items-center border-b border-light">
						<span className="font-normal text-base text-light-grey text-center px-5">
							{t('requestsAndOffers.goodChoiceSelecting', {
								specialist: specialist?.first_name + ' ' + specialist?.last_name,
							})}
						</span>
					</div>
					<div className="w-full flex justify-end items-center px-5 pb-5 gap-3">
						<Button
							sx={{ backgroundColor: 'white', color: '#343A40', fontWeight: 'bold' }}
							variant="contained"
							onClick={onClose}
						>
							{t('requestsAndOffers.decline')}
						</Button>
						<Button
							color="primary"
							variant="contained"
							sx={{ fontWeight: 'bold' }}
							loading={loading}
							onClick={onSuccess}
						>
							{t('requestsAndOffers.confirm')}
						</Button>
					</div>
				</div>
			}
		/>
	);
}
